import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { UserAccessData } from '../core/models/user-access.model';
import { DateFormatService } from '../core/services/date-format.service';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css',
})
export class UserProfileComponent implements OnInit, OnDestroy {
  @Input() profileData: UserAccessData | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() logoutRequested = new EventEmitter<void>();

  constructor(private dateFormatSvc: DateFormatService) {}

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  get fullName(): string {
    const first = this.profileData?.FirstName ?? '';
    const last = this.profileData?.LastName ?? '';
    return [first, last].filter(Boolean).join(' ') || '—';
  }

  get expirationDisplay(): string {
    return this.dateFormatSvc.format(this.profileData?.ExpirationOn ?? null) || '';
  }

  get isActive(): boolean {
    const val = this.profileData?.IsActive;
    if (val == null) return true;
    return val === true || val === 1;
  }

  get isRCMember(): boolean {
    if (this.profileData?.RoleName?.toLowerCase() === 'r&c member') return true;
    const val = this.profileData?.IsRCMember;
    if (val == null) return false;
    return val === true || val === 1;
  }

  get country(): string { return this.profileData?.Country ?? ''; }
  get workLocation(): string { return this.profileData?.WorkLocation ?? ''; }
  get rcMemberSponsor(): string { return this.profileData?.RCMemberSponsor ?? ''; }

  onOverlayClick(): void {
    this.close.emit();
  }

  onLogout(): void {
    this.logoutRequested.emit();
  }
}
